<template>
  <el-table
    :data="trackings()"
    style="width: 100%"
  >
    <el-table-column
      prop="consignment_item"
      label="Barcode"
      :filters="references"
      :filter-method="filterBarcode"
      :formatter="(row, col, cellValue) => cellValue ? cellValue.item_full : consignment.con_full"
    />
    <el-table-column
      prop="level.name"
      label="Level"
    />
    <el-table-column
      prop="scan.text"
      label="Carrier Event"
    />
    <el-table-column
      prop="scan.depot"
      label="Depot"
    />
    <el-table-column
      prop="scan.signed_by"
      label="Signed By"
    />
    <el-table-column
      label="Scanned At"
      prop="scan.scanned_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
    />
    <el-table-column
      label="Created At"
      prop="created_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD/MM/YYYY hh:mm a') : '-'"
    />
    <el-table-column label="POD">
      <template slot-scope="scope">
        <el-button
          v-if="scope.row.scan && scope.row.scan.proof_of_delivery"
          plain
          type="primary"
          icon="el-icon-download"
          size="mini"
          @click="$file.download(scope.row.scan.proof_of_delivery.id)"
        />
      </template>
    </el-table-column>
    <el-table-column
      label="Actions"
      align="right"
    >
      <template slot-scope="scope">
        <el-button-group class="pr-2">
          <el-button
            size="mini"
            @click.native="viewNotifications(scope.row)"
          >
            Notifications
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteTracking(scope.row)"
          >
            Delete
          </el-button>
        </el-button-group>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import Vue from 'vue'
import NotifcationEventDialog from './NotifcationEventDialog'

export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      references: [],
      notificationEventDialogInstance: undefined
    }
  },
  created () {
    this.collectReferences()
  },
  methods: {
    viewNotifications (tracking) {
      const NotifcationEventDialogClass = Vue.extend(NotifcationEventDialog)

      this.notificationEventDialogInstance = new NotifcationEventDialogClass({
        propsData: {
          resource: tracking
        }
      })

      this.notificationEventDialogInstance.$on('destroy', () => {
        this.notificationEventDialogInstance.$destroy()
        this.notificationEventDialogInstance.$el.remove()
        this.notificationEventDialogInstance = undefined
      })

      this.notificationEventDialogInstance.$mount()
      this.$root.$el.appendChild(this.notificationEventDialogInstance.$el)
    },
    deleteTracking (tracking) {
      this.$confirm('Are you sure you want to delete this tracking event?', 'Warning', {
        type: 'warning'
      }).then(() => {
        tracking.delete().then(() => {
          this.$message({
            type: 'success',
            message: 'Tracking event deleted successfully'
          })
          this.consignment.trackings = this.consignment.trackings.filter(t => t.id !== tracking.id)
          this.queueBlobUpdate()
        }).catch(() => {
          this.$message({
            type: 'error',
            message: 'Failed to delete tracking event'
          })
        })
      }).catch(() => {})
    },
    queueBlobUpdate () {
      const job = new this.$sdk.job()
      job.name = 'tracking.blob.update'
      job.parameters = {
        consignment: this.consignment.id
      }
      job.create()
        .then(() => this.$message({ message: this.consignment.con_full + ' Tracking Update Queued', type: 'success' }))
    },
    trackings () {
      const trackings = this.$_.clone(this.consignment.trackings).reverse()
      return trackings
    },
    filterBarcode (value, row) {
      let reference
      if (row.consignment_item) {
        reference = row.consignment_item['item_full']
      } else if (row.consignment) {
        reference = row.consignment['con_full']
      }

      return reference === value
    },
    collectReferences () {
      let refs = []
      this.consignment.trackings.forEach(tracking => {
        if (tracking.consignment_item) {
          refs.push({ text: tracking.consignment_item['item_full'], value: tracking.consignment_item['item_full'] })
        }
      })
      refs.push({ text: this.consignment.con_full, value: this.consignment.con_full })
      this.references = this.$_.uniqBy([ ...new Set(refs) ], 'value')
    }
  }
}
</script>
